/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IDlvryAlternativeProductsViewProps, IProductComponentViewProps } from './dlvry-alternative-products';
import { INodeProps, Module, Node } from '@msdyn365-commerce-modules/utilities';

const ProductCollectionView: React.FC<IDlvryAlternativeProductsViewProps> = props => {
    const { heading, ProductCollectionContainer, products, SingleSlideCarouselComponentProps } = props;
    if (products) {
        return (
            <Module {...ProductCollectionContainer}>
                {heading}
                {_renderCarousel(SingleSlideCarouselComponentProps, products)}
            </Module>
        );
    }
    return null;
};

const _renderCarousel = (carouselContainer: INodeProps, items: IProductComponentViewProps[]): JSX.Element => {
    return <Node {...carouselContainer}>{items && items.map(_renderProduct)}</Node>;
};

const _renderProduct = (product: IProductComponentViewProps): JSX.Element => {
    const { ProductContainer, productComponent } = product;

    return <Node {...ProductContainer}>{productComponent}</Node>;
};

export default ProductCollectionView;
